import { mix, observable, passthruLayout, watch } from "@chorda/core";
export const Lazy = (props) => {
    return mix({
        layout: passthruLayout,
        templates: {
            lazy: null,
            fallback: props.initial
        },
        reactions: {
            // lazyComponent: v => ({components: {
            //     lazy: v,
            //     fallback: !v
            // }}),
            lazyComponent: v => ({ components: {
                    lazy: v,
                    fallback: !v
                } })
        },
        defaults: {
            lazyComponent: () => observable(null),
            isLazyLoad: () => observable(false),
        },
        injections: {
            isLazyLoad: props.isLazyLoad$,
            loadLazy: $ => () => {
                $.isLazyLoad.$value = true;
            }
        },
        joints: {
            lazyLoad: ({ isLazyLoad, lazyComponent }) => {
                watch(() => {
                    if (isLazyLoad.$value) {
                        setTimeout(() => {
                            props.lazy().then(c => lazyComponent.$value = c);
                        }, 2000);
                    }
                }, [isLazyLoad]);
            }
        }
    });
};
